import { Modal, Typography, Box } from '@mui/material'
import React, { useState } from 'react'
import { ReactComponent as KeepFileIcon } from '../assets/keep-file.svg'
import AdxButton from 'components/custom/AdxButton'

const KeepTalentModal = ({ handleKeep }) => {
  const [open, setOpen] = useState(false)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  return (
    <React.Fragment>
      <AdxButton variant={'outlined'} onClick={handleToggle} sx={{ width: 1 / 2 }}>
        Keep talent
      </AdxButton>
      <Modal
        open={open}
        onClose={handleToggle}
        sx={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Box
          sx={{
            backgroundColor: 'white.main',
            borderRadius: '6.5px',
            padding: '32px',
            maxWidth: '600px',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              width: '90px',
              height: '90px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '100%',
              backgroundColor: 'default-background.main',
              marginBottom: '20px',
            }}
          >
            {/* <Icon sx={{ color: 'alternate.main', fontSize: '60px' }}>error</Icon> */}
            <KeepFileIcon />
          </Box>
          <Typography variant="h4" sx={{ textAlign: 'center', marginBottom: '6px' }}>
            Do you confirm to keep this talent?
          </Typography>
          <Typography
            sx={{ color: 'light-gray-text.main', marginBottom: '40px', textAlign: 'center' }}
          >
            By clicking 'confirm', all other talents in this group will be permanently removed from
            your external talents list
          </Typography>
          <AdxButton
            variant={'contained'}
            onClick={handleKeep}
            fullWidth
            sx={{ marginBottom: '8px' }}
          >
            Confirm and remove others
          </AdxButton>
          <AdxButton variant={'ghost'} onClick={handleToggle} fullWidth>
            Cancel
          </AdxButton>
        </Box>
      </Modal>
    </React.Fragment>
  )
}

export default KeepTalentModal
